<form [formGroup]="form">
  <portal-modal-header
    [title]="'meeting.resetPinOrToken' | translate"
    (onClose)="dismiss()"
  ></portal-modal-header>

  <portal-modal-body>
    <p>{{ 'meeting.resetPinOrToken.description' | translate }}</p>

    <!-- Admin pin -->
    <div class="form-check">
      <input
        class="form-check-input"
        id="adminPin"
        formControlName="type"
        name="type"
        type="radio"
        value="adminPin"
      />

      <label class="form-check-label" for="adminPin">
        {{ 'meeting.resetAdminPin' | portalTranslate }}
      </label>
    </div>

    <!-- User pin -->
    <div class="form-check">
      <input
        class="form-check-input"
        id="userPin"
        formControlName="type"
        name="type"
        type="radio"
        value="userPin"
      />

      <label class="form-check-label" for="userPin">
        {{ 'meeting.resetUserPin' | portalTranslate }}
      </label>
    </div>

    <!-- User token -->
    <div class="form-check">
      <input
        class="form-check-input"
        id="userToken"
        formControlName="type"
        name="type"
        type="radio"
        value="userToken"
      />

      <label class="form-check-label" for="userToken">
        {{ 'meeting.resetUserToken' | portalTranslate }}
      </label>
    </div>
  </portal-modal-body>

  <portal-modal-footer
    [errors]="form.errors"
    [invalid]="form.invalid"
    [saving]="saving"
    (onCancel)="dismiss()"
    (onSave)="submit()"
  ></portal-modal-footer>
</form>
